import { APP_PERMISSIONS } from '@exam-center/permission';
import { PageNotFound, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function PermissionRequiredExamLocationManagementCancellationsPage() {
  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_CANCELATION.VIEW]}
    >
      {/*<ExamLocationManagementCancellationsPage />*/}
      <PageNotFound />
    </PermissionGuard>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ExamLocationManagementCancellationsPage() {
  return <PaperSection title='ยกเลิกการใช้งาน' />;
}
